import(/* webpackMode: "eager", webpackExports: ["BiteAppShell"] */ "/home/runner/work/ticker-bullstory/ticker-bullstory/frontend/src/components/bite/bite-app-shell.tsx");
